import { render, staticRenderFns } from "./ForumThreadPost.vue?vue&type=template&id=ebeedce4&"
import script from "./ForumThreadPost.vue?vue&type=script&lang=js&"
export * from "./ForumThreadPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebeedce4')) {
      api.createRecord('ebeedce4', component.options)
    } else {
      api.reload('ebeedce4', component.options)
    }
    module.hot.accept("./ForumThreadPost.vue?vue&type=template&id=ebeedce4&", function () {
      api.rerender('ebeedce4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/forum/ForumThreadPost.vue"
export default component.exports